import { render, staticRenderFns } from "./AddResults.vue?vue&type=template&id=11f65526&"
import script from "./AddResults.vue?vue&type=script&lang=js&"
export * from "./AddResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports